import React from 'react';
import './Button.css';
type Buttontype = {
  onClick: () => void;
  disabled?: boolean;
  buttonName: string;
  colorType: string;
  icon?: React.ReactNode;
  iconPosition?: string;
  id: string;
};
const Button: React.FC<Buttontype> = ({
  onClick,
  disabled,
  buttonName,
  colorType,
  id,
  iconPosition,
  icon,
}) => {
  return (
    <div className="button_common_component">
      <button
        type="button"
        onClick={onClick}
        id={id}
        className={`adding_the_dynamic_button ${colorType} `}
        disabled={disabled}
      >
        {icon && iconPosition === 'left' && (
          <span className="button_icon_iconposition">{icon}</span>
        )}
        <span className="button_inner_text">{buttonName}</span>
        {icon && iconPosition === 'right' && (
          <span className="button_icon_iconposition">{icon}</span>
        )}
      </button>
    </div>
  );
};

export default Button;
